module.exports = __webpack_public_path__ + "assets/img/2211591934007_.pic_hd.95c68de5.jpg";